import React from 'react';
import classnames from 'classnames';

interface AuthFormContainerProps {
  children: React.ReactNode;
  contentClass?: string; //provide width
}

export const AuthFormContainer: React.FC<AuthFormContainerProps> = ({children, contentClass = 'w-[46rem]'}) => (
  <div className="form-container-wrapper">
    <div className="form-container">
      <div className="w-full flex justify-center">
        <div className="form-container-background">
          <div className="form-container-filter" />
        </div>
        <div className={classnames('form-content', contentClass)}>{children}</div>
      </div>
    </div>
  </div>
);
